import { useT } from '@powerportalspro/react';
import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  ChartLegendPosition,
  ChartType,
} from '@powerportalspro/react-charts';
import { DataverseChart, Section, SectionColumn } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';

// The open pipeline by when the customer means to buy, twice: the same grouping, with a different
// aggregate. The first counts the opportunities (`QueryAggregate.Count`), the second adds up their
// estimated value (`QueryAggregate.Sum`) — a few large deals can outweigh many small ones. The
// legends sit beside the rings (`legendPosition={ChartLegendPosition.Right}`).

const STRINGS_BASE = 'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.ChartDemos.DoughnutChartShowcaseMainDemo';

const OPEN_ONLY = "<filter><condition attribute='statecode' operator='eq' value='0' /></filter>";

export function DoughnutChartShowcaseMainSample() {
  const t = useT();

  const countByTimeframe = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'purchasetimeframe',
        aggregateColumn: 'opportunityid',
        aggregate: QueryAggregate.Count,
        filterXml: OPEN_ONLY,
        singleSeriesLabel: t(`${STRINGS_BASE}.count-series-label`),
      }),
    [t],
  );

  const valueByTimeframe = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'purchasetimeframe',
        aggregateColumn: 'estimatedvalue',
        aggregate: QueryAggregate.Sum,
        filterXml: OPEN_ONLY,
        singleSeriesLabel: t(`${STRINGS_BASE}.value-series-label`),
      }),
    [t],
  );

  return (
    <Section borderVisible={false}>
      <SectionColumn>
        <DataverseChart
          dataSource={countByTimeframe}
          type={ChartType.Doughnut}
          title={t(`${STRINGS_BASE}.count-title`)}
          legendPosition={ChartLegendPosition.Right}
          height="380px"
        />
      </SectionColumn>
      <SectionColumn>
        <DataverseChart
          dataSource={valueByTimeframe}
          type={ChartType.Doughnut}
          title={t(`${STRINGS_BASE}.value-title`)}
          legendPosition={ChartLegendPosition.Right}
          height="380px"
        />
      </SectionColumn>
    </Section>
  );
}
